<section class="row mb-2">
  <div class="col-md-4 col-xs-12"></div>
  <div class="col-md-4 col-xs-12"></div>
  <div class="col-md-4 col-xs-12 backToDash">
    <a (click)='backToDashBoard()'>
      <img src='/icons/{{baseSiteId}}/chevron-left_green.svg' class="svg-Images" style="width:15px;" alt="left">
      <span class="bc-Dash-Div">Back to dashboard</span></a>
    </div>
  </section>
  <div class="container vaccineLocatorContent">
    <div class="row row-20 vacc_loc" id="vaccineLocator">
      <section class="col-md-12 col-sm-12 col-xs-12">
        <div class="loc_notifi">
          <div class="col-md-7 col-sm-7 col-xs-12 pl0">
            <h6>{{totalactiveLocationsCount}} of your {{totalLocationsCount}} locations are active</h6>
          </div>

          <div class="col-md-5 col-sm-5 col-xs-12 Search-holder pr0">
            <div class="input-group SearchBar">
              <input type="text" class="form-control" placeholder="Search by location name, city, zip code"
                [(ngModel)]="searchText" id="locationSearch" (ngModelChange)="test($event)" data-di-id="#locationSearch">
              <span class="input-group-btn">
                <button class="btn btn-default" type="button">
                  <span class="searchIcon"></span>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="vacc_table">
          <table aria-describedby="locatorTable" id="vaccineLocatorTable" class="inflzTab_table table-striped">
            <thead>
              <tr>
                <th scope="col" style="width: 6%;">
                  <div class="col-md-2 radioAlign">
                    <label class="mb-3">
                      <span class="checkmark multi_check" style="margin-top:10px;"></span>
                      <input type="checkbox" id="checkAll" [checked]="locationSelectorOn" name="locationSelectorOn"
                        [(ngModel)]="locationSelectorOn" (ngModelChange)="applySettingAll()" data-di-id="#checkAll"> <span
                      class="checkmark multi_check" style="margin-top:10px;"></span>
                    </label>
                  </div>
                </th>
                <th scope="col" style="width: 10%;" (click)="sortColumn($event, 'active', ordersList, 'normal')">
                  Active
                  <i class="my-icon fas fa-caret-down"></i>
                </th>
                <th scope="col" style="width: 21%;" (click)="sortColumn($event, 'location', ordersList, 'normal')">
                  Location
                  <i class="my-icon fas fa-caret-down"></i>
                </th>
                <th scope="col" style="width: 21%;" (click)="sortColumn($event, 'location', ordersList, 'normal')">
                  Address
                  <i class="my-icon fas fa-caret-down"></i>
                </th>
                <th scope="col" style="width: 12%;">
                  Phone
                </th>
                <th scope="col" style="width: 15%;" (click)="sortColumn($event, 'flubok', ordersList, 'normal')">
                  Flubok Influenza Vaccine
                </th>
                <th scope="col" style="width: 15%;" (click)="sortColumn($event, 'fluzone', ordersList, 'normal')">
                  Fluzone High-Dose Influenza Vaccine
                </th>
                <th scope="col" style="width: 6%;">

                </th>
              </tr>
            </thead>
            <tbody>
              @if (locationSelectorOn) {
                <tr>
                  <td></td>
                  <td class="status-txt loc-switch align-baseline">
                    <span class="loc_stat">
                      <label class="switch">
                        <input type="checkbox" class="imCheck" name="isAllActive" [(ngModel)]="isAllActive"
                          (click)="changeEnrollFlag('All','enrollflag',$event)">
                        <span class="slider round"></span>
                      </label>
                      @if (isAllActive) {
                        <span>Active</span>
                      }
                      @if (!isAllActive) {
                        <span>Inactive</span>
                      }
                    </span>
                  </td>
                  <td colspan="2" class="locationSelector align-baseline">
                    <div class="p-4">
                      <span class="d-block mb-2">All locations selected({{totalLocationsCount}})</span>
                      <div class="loc-btn mob-loc-btn recursive-loc-btn">
                        <button class="popover-close btn white-button popover-cancel-button mr-1">
                          <a (click)="cancelAllLocation()">Cancel</a></button>
                          <button class="btn btn-primary applyBtnStl" (click)="clickApplytoAll()" data-toggle="popover"
                            data-placement="top" data-target="apply_all" data-original-title="" title="">
                          Apply to all</button>
                          <!--Popover content for Delete start-->
                          @if (confirmStatus) {
                            <div class="edit-popover rr_apply-all">
                              <div class="hide" id="apply_all">
                                <p class="bold-12 product_trash product_trash_text">
                                Are you sure you want to apply these settings to all the locations selected?</p>
                                <button (click)="cancelPopUp()"
                                  class="popover-close btn white-button popover-cancel-button mr-1">
                                Cancel</button>
                                <button class="btn btn-primary" (click)="callsaveAction()">
                                &nbsp;Apply&nbsp;</button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </td>
                    <td></td>
                    <td class="status-txt loc-switch align-baseline pl-1">
                      @if (isAllActive) {
                        <span class="loc_stat">
                          <label class="switch">
                            <input type="checkbox" class="imCheck" name="isAllFlubokActive" [(ngModel)]="isAllFlubokActive"
                              (click)="changeEnrollFlag('All','flubokActive',$event)">
                            <span class="slider round"></span>
                          </label>
                          @if (!isAllFlubokActive) {
                            <span>Not Offered</span>
                          }
                          @if (isAllFlubokActive) {
                            <span>Offered</span>
                          }
                        </span>
                      }
                    </td>
                    <td class="status-txt loc-switch align-baseline pl-1">
                      @if (isAllActive) {
                        <span class="loc_stat">
                          <label class="switch">
                            <input type="checkbox" class="imCheck" name="isAllFlubokHighDoseActive"
                              [(ngModel)]="isAllFlubokHighDoseActive"
                              (click)="changeEnrollFlag('All','flubokHighDoseActive',$event)">
                            <span class="slider round"></span>
                          </label>
                          @if (!isAllFlubokHighDoseActive) {
                            <span>Not Offered</span>
                          }
                          @if (isAllFlubokHighDoseActive) {
                            <span>Offered</span>
                          }
                        </span>
                      }
                    </td>
                    <td></td>
                  </tr>
                }
                @if (ordersList?.length>0) {
                  @for (data of ordersList; track data; let i = $index) {
                    @if (!data.editModeOn) {
                      <tr id="{{'rowIdOnRead'+i}}">
                        <td style="width: 6%;">
                          <div class="input-wrapper-div">
                            <label class="mb-3">
                              @if (data?.thisEleChecked) {
                                <input checked (click)="selectRadioFrRw(data?.locatorId, $event)"
                                  type="checkbox" class="row-selector">
                              }
                              @if (!data?.thisEleChecked) {
                                <input (click)="selectRadioFrRw(data?.locatorId, $event)"
                                  type="checkbox" class="row-selector">
                              }
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </td>
                        <td style="width: 10%;" class="status-txt loc-switch pl-1">
                          <span class="loc_stat">
                            <label class="switch"> @if (data.statusId!=2) {
                              <input type="checkbox" class="imCheck"
                                (click)="changeEnrollFlag(data?.locatorId,'enrollflag',false)"
                                checked>
                            }
                            @if (data.statusId==2) {
                              <input type="checkbox" class="imCheck"
                                (click)="changeEnrollFlag(data?.locatorId,'enrollflag',true)">
                            }
                            <span class="slider round"></span>
                          </label>
                          @if (data?.statusId!=2) {
                            <span>Active</span>
                          }
                          @if (data?.statusId==2) {
                            <span>Inactive</span>
                          }
                        </span>
                      </td>
                      <td style="width: 21%;">
                        <span>{{data.customerName}}</span>
                      </td>
                      <td style="width: 21%;" class="status-txt">
                        <span>{{data.address}}, {{data.city}}, {{data.state}}, {{data.zipcode}}</span>
                      </td>
                      <td style="width: 12%;" class="status-txt">
                        <span> {{data.phone}}</span>
                      </td>
                      <td style="width: 12%;" class="status-txt loc-switch pl-1">
                        <span class="loc_stat">
                          @if (data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available') {
                            <label class="switch">
                              @if (data?.fluBlockOptedIn=='Offered') {
                                <input type="checkbox" class="imCheck"
                                  (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',false)"
                                  checked>
                              }
                              @if (data?.fluBlockOptedIn!='Offered') {
                                <input type="checkbox" class="imCheck"
                                  (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',true)"
                                  >
                              }
                              <span class="slider round"></span>
                            </label>
                          }
                          @if (data?.statusId!=2 && data?.fluBlockOptedIn) {
                            <span>{{data?.fluBlockOptedIn}}</span>
                          }
                          @if (data?.statusId!=2 && !data?.fluBlockOptedIn) {
                            <span>Not Available</span>
                          }
                        </span>
                      </td>
                      <td style="width: 12%;" class="status-txt loc-switch pl-2">
                        <span class="loc_stat">
                          @if (data?.statusId!=2) {
                            <span>{{data?.fluZoneOptedIn}}</span>
                          }
                          @if (data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available') {
                            <label class="switch">
                              @if (data?.fluZoneOptedIn=='Offered') {
                                <input type="checkbox" class="imCheck"
                                  (click)="changeEnrollFlag(data?.locatorId,'flubokActive',false)"
                                  checked>
                              }
                              @if (data?.fluZoneOptedIn!='Offered') {
                                <input type="checkbox" class="imCheck"
                                  (click)="changeEnrollFlag(data?.locatorId,'flubokActive',true)"
                                  >
                              }
                              <span class="slider round"></span>
                            </label>
                          }
                        </span>
                      </td>
                      <td class="loc-edit">
                        <div class="show-msg alert-danger common-error" style="display: none;">
                          Please select the check box to make changes
                        </div>
                        @if (!editOn && !locationSelectorOn) {
                          <div class="d-flex p-1 pt-3"><img class="editIcon"
                            src="/icons/editIcon.png" alt="icon">
                            <a class="edit allctn-edit" href="javascript:void(0);" (click)="editModeOn(data.locatorId)"
                            target="" title="Edit">Edit</a>
                          </div>
                        }
                        @if (editOn || locationSelectorOn) {
                          <div class="d-flex p-1"><img class="editIcon"
                            src="/icons/edit_disable.svg" alt="icon">
                            <a class="allctn-edit2" target="" title="Edit">Edit</a>
                          </div>
                        }
                      </td>
                    </tr>
                  }
                  @if (data.editModeOn) {
                    <tr id="{{'rowId'+i}}">
                      <td colspan="8">
                        <div class="row pt-3 pb-3">
                          <div class="col-xs-12 col-md-2">
                            <div class="status-txt loc-switch float-right">
                              <span class="loc_stat">
                                <label class="switch">
                                  @if (data.statusId!=2) {
                                    <input type="checkbox" class="imCheck"
                                      (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',false)"
                                      checked>
                                  }
                                  @if (data.statusId==2) {
                                    <input type="checkbox" class="imCheck"
                                      (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',true)"
                                      >
                                  }
                                  <span class="slider round"></span>
                                </label>
                                @if (data.statusId!=2) {
                                  <span>Active</span>
                                }
                                @if (data.statusId==2) {
                                  <span>Inactive</span>
                                }
                              </span>
                            </div>
                          </div>
                          <div class="col-xs-12 col-md-6">
                            <div class="row mb-3">
                              <div class="col-xs-12 col-md-8">
                                <div class="inputTitle">
                                  <label class="mb-2">
                                    Location name
                                  </label>
                                  <input #locationName class="texttype2 w-90 ml-4"
                                    (keyup)="inputValidation(locationName.value,'name')" type="text"
                                    [(ngModel)]="dataSetForEdit.customerName" name="location"><br />
                                    @if (nameErrorMsg) {
                                      <span class="redmsgFax">This field is required</span>
                                    }
                                  </div>
                                </div>
                                <div class="col-xs-12 col-md-4">
                                  <div class="inputTitle">
                                    <label class="mb-2">
                                      Account #
                                    </label>
                                    <input #locationName class="texttype2 w-90 ml-4" type="text"
                                      [(ngModel)]="dataSetForEdit.mdg_num" name="account" disabled><br />
                                    </div>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-xs-12 col-md-8">
                                    <div class="inputTitle">
                                      <label class="mb-2">
                                        Address
                                      </label>
                                      <input #address class="texttype2 w-90 ml-4"
                                        (keyup)="inputValidation(address.value,'address')" type="text"
                                        [(ngModel)]="dataSetForEdit.address" name="address"><br />
                                        @if (addressErrorMsg) {
                                          <span class="redmsgFax">This field is required</span>
                                        }
                                      </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4">
                                      <div class="inputTitle">
                                        <label class="mb-2">
                                          Phone
                                        </label>
                                        <input type="text" #phoneNumber
                                onkeypress="return
                                  (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                class="texttype w-90 ml-4"
                                          (keyup)="validateFaxNumber(phoneNumber.value,'phone',dataSetForEdit.locatorId)"
                                          [(ngModel)]="dataSetForEdit.phone" id="faxcontactmethod{{i}}" name="fax{{i}}">
                                        @if (phoneErrorMsg) {
                                          <span class="redmsgFax">This field is required</span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-xs-12 col-md-4">
                                      <div class="inputTitle">
                                        <label class="mb-2">
                                          City
                                        </label>
                                        <input #city class="texttype2 w-90 ml-4" (keyup)="cityvalidation(city.value)" type="text"
                                          [(ngModel)]="dataSetForEdit.city" name="address"><br />
                                          @if (cityErrorMsg) {
                                            <span class="redmsgFax">This field is required</span>
                                          }
                                          @if (cityErrorMsg2) {
                                            <span class="redmsgFax redmsgCity">This field accepts alphabets and
                                            spaces.</span>
                                          }
                                        </div>
                                      </div>
                                      <div class="col-xs-12 col-md-4">
                                        <div class="inputTitle vax-location">
                                          <label class="mb-2">
                                            State
                                          </label>
                                          <ng-select [items]="statesArr" bindLabel="isocode" [clearable]="false"
                                            placeholder="Please select" [(ngModel)]="dataSetForEdit.state" name="state">
                                        </ng-select>
                                      </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4">
                                      <div class="inputTitle">
                                        <label class="mb-2">
                                          Zip code
                                        </label>
                                        <input #zip class="texttype2 w-90 ml-4" (keyup)="numberValidation(zip.value)" type="text"
                                          [(ngModel)]="dataSetForEdit.zipcode" name="zipcode"><br />
                                          @if (zipcodeErrorMsg) {
                                            <span class="redmsgFax">This field is required</span>
                                          }
                                          @if (zipcodeErrorMsg2) {
                                            <span class="redmsgFax redmsgCity">Please enter valid zip
                                            code</span>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row mb-3 mt-4">
                                      <div class="col-xs-12 col-md-12">
                                        <div class="ml-4">
                                          <button (click)="cancelEditSection(data.locatorId)"
                                            class="popover-close btn white-button popover-cancel-button mr-3">
                                        Cancel</button>
                                        @if (phoneErrorMsg||cityErrorMsg||cityErrorMsg2 || zipcodeErrorMsg2 || zipcodeErrorMsg || addressErrorMsg || nameErrorMsg) {
                                          <button
                                            disabled (click)="SaveAction()" class="btn btn-primary">
                                          &nbsp;Save&nbsp;</button>
                                        }
                                        @if (!phoneErrorMsg && !cityErrorMsg2 && !zipcodeErrorMsg2 && !zipcodeErrorMsg && !addressErrorMsg && !nameErrorMsg) {
                                          <button
                                            (click)="SaveAction()" class="btn btn-primary">
                                          &nbsp;Save&nbsp;</button>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xs-12 col-md-4">
                                  <div class="row">
                                    <div class="col-5 ml-3">
                                      <div class="status-txt loc-switch">
                                        @if (data.isSelected) {
                                          <span class="loc_stat">
                                            @if (data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available') {
                                              <label class="switch"
                                                > @if (data?.fluBlockOptedIn=='Offered') {
                                                <input
                                                  type="checkbox" class="imCheck"
                                                  (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',false)"
                                                  checked>
                                              }
                                              @if (data?.fluBlockOptedIn!='Offered') {
                                                <input type="checkbox" class="imCheck"
                                                  (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',true)"
                                                  >
                                              }
                                              <span class="slider round"></span>
                                            </label>
                                          }
                                          @if (data?.statusId!=2) {
                                            <span>{{data?.fluBlockOptedIn}}</span>
                                          }
                                        </span>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-5 ml-2 p-0">
                                    <div class="status-txt loc-switch">
                                      <span class="loc_stat">
                                        @if (data?.statusId!=2) {
                                          <span>{{data?.fluZoneOptedIn}}</span>
                                        }
                                        @if (data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available') {
                                          <label class="switch"
                                            > @if (data?.fluZoneOptedIn=='Offered') {
                                            <input
                                              type="checkbox" class="imCheck"
                                              (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',false)"
                                              checked>
                                          }
                                          @if (data?.fluZoneOptedIn!='Offered') {
                                            <input type="checkbox" class="imCheck"
                                              (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',true)"
                                              >
                                          }
                                          <span class="slider round"></span>
                                        </label>
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  }
                }

                @if (ordersList?.length==0) {
                  <tr>
                    <td colspan="7" class="alignCenter">No matching locations</td>
                  </tr>
                }

              </tbody>
            </table>
            <!--table ends-->

            <!--mobile view starts-->
            <div id="applyVaccineLocatorTable">

              <div class="mb-location">

                <div class="restCols">

                  <div class="row">
                    <div class="col-6 radioAlign">
                      <label class="mb-3">
                        <span class="checkmark multi_check" style="margin-top:10px;"></span>
                        <input type="checkbox" id="checkAll" [checked]="locationSelectorOn" name="locationSelectorOn"
                          [(ngModel)]="locationSelectorOn" (ngModelChange)="applySettingAll()" data-di-id="#checkAll"> <span
                        class="checkmark multi_check" style="margin-top:10px;"></span>
                      </label>
                    </div>
                    <div class="col-6 topMargin-select">
                      Location
                    </div>
                  </div>

                </div>

              </div>

              <div>

                @if (locationSelectorOn) {
                  <div class="p-1 pb-2 bg-location">
                    <div class="locationSelector locationSelector-height">
                      <span>All locations selected({{totalLocationsCount}})</span>
                      <div class="status-txt loc-switch st-outline">
                        <span class="loc_stat">
                          <label class="switch">
                            <input type="checkbox" class="imCheck" name="isAllActive" [(ngModel)]="isAllActive"
                              (click)="changeEnrollFlag('All','enrollflag',$event)">
                            <span class="slider round"></span>
                          </label>
                          @if (isAllActive) {
                            <span>Active</span>
                          }
                          @if (!isAllActive) {
                            <span>Inactive</span>
                          }
                        </span>
                      </div>
                      <div class="status-txt loc-switch st-outline">
                        @if (isAllActive) {
                          <span class="loc_stat">
                            <label class="switch">
                              <input type="checkbox" class="imCheck" name="isAllFlubokActive" [(ngModel)]="isAllFlubokActive"
                                (click)="changeEnrollFlag('All','flubokActive',$event)">
                              <span class="slider round"></span>
                            </label>
                            @if (!isAllFlubokActive) {
                              <span>Not Offered</span>
                            }
                            @if (isAllFlubokActive) {
                              <span>Offered</span>
                            }
                          </span>
                        }
                      </div>
                      <div class="status-txt loc-switch st-outline">
                        @if (isAllActive) {
                          <span class="loc_stat">
                            <label class="switch">
                              <input type="checkbox" class="imCheck" name="isAllFlubokHighDoseActive"
                                [(ngModel)]="isAllFlubokHighDoseActive"
                                (click)="changeEnrollFlag('All','flubokHighDoseActive',$event)">
                              <span class="slider round"></span>
                            </label>
                            @if (!isAllFlubokHighDoseActive) {
                              <span>Not Offered</span>
                            }
                            @if (isAllFlubokHighDoseActive) {
                              <span>Offered</span>
                            }
                          </span>
                        }
                      </div>
                      <div id="AllBtn" class="loc-btn mob-loc-btn recursive-loc-btn mt-1">
                        <button class="popover-close btn white-button popover-cancel-button mr-1">
                          <a (click)="cancelAllLocation()">Cancel</a></button>
                          <button class="btn btn-primary applyBtnStl" (click)="clickApplytoAll();toggle(p2)"
                            [ngbPopover]="popContentDeleteMob" triggers="manual" #p2="ngbPopover" placement="top"
                            popoverClass="custom-rec-reserv-popover-mob">
                          Apply to all</button>
                          <!--Popover content for Delete start-->
                          <ng-template #popContentDeleteMob>
                            <div>
                              <div class="hide" id="apply_all">
                                <p class="bold-12 product_trash product_trash_text">
                                Are you sure you want to apply these settings to all the locations selected?</p>
                                <div class="d-flex">
                                  <button (click)="toggle(p2)"
                                    class="btn-secondary">
                                  Cancel</button>
                                  <button class="btn-primary ml-1" (click)="callsaveAction();toggle(p2)">
                                  &nbsp;Apply&nbsp;</button>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                @if (ordersList?.length>0) {
                  @for (data of ordersList; track data; let i = $index) {
                    <section class="pt-3">
                      @if (!data.editModeOn) {
                        <div id="{{'rowIdOnReadMob'+i}}">
                          <div class="row p-1">
                            <div class="col-6 mb-1">
                              <label class="col-title">
                                Select
                              </label>
                            </div>
                            <div class="col-6 mt-2 p-2 select-radio-div">
                              <label>
                                @if (data?.thisEleChecked) {
                                  <input checked (click)="selectRadioFrRw(data?.locatorId, $event)"
                                    type="checkbox" class="row-selector">
                                }
                                @if (!data?.thisEleChecked) {
                                  <input (click)="selectRadioFrRw(data?.locatorId, $event)"
                                    type="checkbox" class="row-selector">
                                }
                                <span class="checkmark"></span>
                              </label>
                            </div>
                            <div class="col-6">
                              <label class="col-title">
                                Location
                              </label>
                            </div>
                            <div class="col-6 mt-2 p-0">
                              <label class="desc">
                                {{data.customerName}}
                              </label>
                            </div>
                            <div class="col-6">
                              <label class="col-title">
                                Address
                              </label>
                            </div>
                            <div class="col-6 mt-2 p-0">
                              <label class="desc">
                                {{data.address}}, {{data.city}}, {{data.state}}, {{data.zipcode}}
                              </label>
                            </div>
                            <div class="col-6">
                              <label class="col-title">
                                Phone
                              </label>
                            </div>
                            <div class="col-6 mt-2 phoneMobilePadding">
                              <label class="desc">
                                {{data.phone}}
                              </label>
                            </div>
                            <div class="col-6">
                              <label class="col-title">
                                Status
                              </label>
                            </div>
                            <div class="col-6 status-txt loc-switch mt-3">
                              <span class="loc_stat">
                                <label class="switch">
                                  @if (data.statusId!=2) {
                                    <input type="checkbox" class="imCheck"
                                      (click)="changeEnrollFlag(data?.locatorId,'enrollflag',false)"
                                      checked>
                                  }
                                  @if (data.statusId==2) {
                                    <input type="checkbox" class="imCheck"
                                      (click)="changeEnrollFlag(data?.locatorId,'enrollflag',true)">
                                  }
                                  <span class="slider round"></span>
                                </label>
                                @if (data?.statusId!=2) {
                                  <span>Active</span>
                                }
                                @if (data?.statusId==2) {
                                  <span>Inactive</span>
                                }
                              </span>
                            </div>
                            <div class="col-6">
                              @if (data?.statusId!=2) {
                                <label class="col-title">
                                  Flubok Influenza Vaccine
                                </label>
                              }
                            </div>
                            <div class="col-6 status-txt loc-switch mt-3">
                              <span class="loc_stat">
                                @if (data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available') {
                                  <label class="switch">
                                    @if (data?.fluBlockOptedIn=='Offered') {
                                      <input type="checkbox" class="imCheck"
                                        (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',false)"
                                        checked>
                                    }
                                    @if (data?.fluBlockOptedIn!='Offered') {
                                      <input type="checkbox" class="imCheck"
                                        (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',true)"
                                        >
                                    }
                                    <span class="slider round"></span>
                                  </label>
                                }
                                @if (data?.statusId!=2) {
                                  <span>{{data?.fluBlockOptedIn}}</span>
                                }
                              </span>
                            </div>
                            <div class="col-6">
                              @if (data?.statusId!=2) {
                                <label class="col-title">
                                  Fluzone High-Dose Influenza Vaccine
                                </label>
                              }
                            </div>
                            <div class="col-6 status-txt loc-switch mt-3">
                              <span class="loc_stat">
                                @if (data?.statusId!=2) {
                                  <span>{{data?.fluZoneOptedIn}}</span>
                                }
                                @if (data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available') {
                                  <label class="switch">
                                    @if (data?.fluZoneOptedIn=='Offered') {
                                      <input type="checkbox" class="imCheck"
                                        (click)="changeEnrollFlag(data?.locatorId,'flubokActive',false)"
                                        checked>
                                    }
                                    @if (data?.fluZoneOptedIn!='Offered') {
                                      <input type="checkbox" class="imCheck"
                                        (click)="changeEnrollFlag(data?.locatorId,'flubokActive',true)"
                                        >
                                    }
                                    <span class="slider round"></span>
                                  </label>
                                }
                              </span>
                            </div>
                            <div class="col-12 text-center">
                              @if (!editOn && !locationSelectorOn) {
                                <div><img class="editIcon"
                                  src="/icons/editIcon.png" alt="icon">
                                  <a class="edit allctn-edit" href="javascript:void(0);" (click)="editModeOn(data.locatorId)"
                                  target="" title="Edit">Edit</a>
                                </div>
                              }
                              @if (editOn || locationSelectorOn) {
                                <div><img class="editIcon"
                                  src="/icons/edit_disable.svg" alt="icon">
                                  <a class="allctn-edit2" target="" title="Edit">Edit</a>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      @if (data.editModeOn) {
                        <div id="{{'rowIdMob'+i}}">
                          <div class="row p-1">
                            <div class="col-6">
                              <label class="col-title">
                                Location
                              </label>
                            </div>
                            <div class="col-6 mt-2 p-0">
                              <input #locationName class="texttype2 w-90"
                                (keyup)="inputValidation(locationName.value,'name')" type="text"
                                [(ngModel)]="dataSetForEdit.customerName" name="location"><br />
                                @if (nameErrorMsg) {
                                  <span class="redmsgFax">This field is required</span>
                                }
                              </div>
                              <div class="col-6">
                                <label class="col-title">
                                  Address
                                </label>
                              </div>
                              <div class="col-6 mt-2 p-0">
                                <input #address class="texttype2 w-90"
                                  (keyup)="inputValidation(address.value,'address')" type="text"
                                  [(ngModel)]="dataSetForEdit.address" name="address"><br />
                                  @if (addressErrorMsg) {
                                    <span class="redmsgFax">This field is required</span>
                                  }
                                </div>
                                <div class="col-6">
                                  <label class="col-title">
                                    Account #
                                  </label>
                                </div>
                                <div class="col-6 mt-2 p-0">
                                  <input #locationName class="texttype2 w-90" type="text"
                                    [(ngModel)]="dataSetForEdit.mdg_num" name="account" disabled><br />
                                  </div>
                                  <div class="col-6">
                                    <label class="col-title">
                                      Phone
                                    </label>
                                  </div>
                                  <div class="col-6 mt-2 phoneMobilePadding">
                                    <input type="text" #phoneNumber
                  onkeypress="return
                    (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  class="texttype w-90"
                                      (keyup)="validateFaxNumber(phoneNumber.value,'phone',dataSetForEdit.locatorId)"
                                      [(ngModel)]="dataSetForEdit.phone" id="faxcontactmethod{{i}}" name="fax{{i}}">
                                    @if (phoneErrorMsg) {
                                      <span class="redmsgFax">This field is required</span>
                                    }
                                  </div>
                                  <div class="col-6">
                                    <label class="col-title">
                                      City
                                    </label>
                                  </div>
                                  <div class="col-6 mt-2 p-0">
                                    <input #city class="texttype2 w-90" (keyup)="cityvalidation(city.value)" type="text"
                                      [(ngModel)]="dataSetForEdit.city" name="address"><br />
                                      @if (cityErrorMsg) {
                                        <span class="redmsgFax">This field is required</span>
                                      }
                                      @if (cityErrorMsg2) {
                                        <span class="redmsgFax redmsgCity">This field accepts alphabets and
                                        spaces.</span>
                                      }
                                    </div>
                                    <div class="col-6">
                                      <label class="col-title">
                                        State
                                      </label>
                                    </div>
                                    <div class="col-6 mt-2 p-0">
                                      <ng-select [items]="statesArr" bindLabel="isocode" [clearable]="false"
                                        placeholder="Please select" [(ngModel)]="dataSetForEdit.state" name="state">
                                    </ng-select>
                                  </div>
                                  <div class="col-6">
                                    <label class="col-title">
                                      Zip code
                                    </label>
                                  </div>
                                  <div class="col-6 mt-2 p-0">
                                    <input #zip class="texttype2 w-90" (keyup)="numberValidation(zip.value)" type="text"
                                      [(ngModel)]="dataSetForEdit.zipcode" name="zipcode"><br />
                                      @if (zipcodeErrorMsg) {
                                        <span class="redmsgFax">This field is required</span>
                                      }
                                      @if (zipcodeErrorMsg2) {
                                        <span class="redmsgFax redmsgCity">Please enter valid zip
                                        code</span>
                                      }
                                    </div>
                                    <div class="col-6">
                                      <label class="col-title">
                                        Status
                                      </label>
                                    </div>
                                    <div class="col-6 status-txt loc-switch mt-3">
                                      <span class="loc_stat">
                                        <label class="switch">
                                          @if (data.statusId!=2) {
                                            <input type="checkbox" class="imCheck"
                                              (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',false)"
                                              checked>
                                          }
                                          @if (data.statusId==2) {
                                            <input type="checkbox" class="imCheck"
                                              (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',true)"
                                              >
                                          }
                                          <span class="slider round"></span>
                                        </label>
                                        @if (data.statusId!=2) {
                                          <span>Active</span>
                                        }
                                        @if (data.statusId==2) {
                                          <span>Inactive</span>
                                        }
                                      </span>
                                    </div>
                                    <div class="col-6">
                                      @if (data.isSelected && data?.statusId!=2) {
                                        <label class="col-title">
                                          Flubok Influenza Vaccine
                                        </label>
                                      }
                                    </div>
                                    <div class="col-6 status-txt loc-switch mt-3">
                                      @if (data.isSelected) {
                                        <span class="loc_stat">
                                          @if (data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available') {
                                            <label class="switch"
                                              > @if (data?.fluBlockOptedIn=='Offered') {
                                              <input
                                                type="checkbox" class="imCheck"
                                                (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',false)"
                                                checked>
                                            }
                                            @if (data?.fluBlockOptedIn!='Offered') {
                                              <input type="checkbox" class="imCheck"
                                                (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',true)"
                                                >
                                            }
                                            <span class="slider round"></span>
                                          </label>
                                        }
                                        @if (data?.statusId!=2) {
                                          <span>{{data?.fluBlockOptedIn}}</span>
                                        }
                                      </span>
                                    }
                                  </div>
                                  <div class="col-6">
                                    @if (data.isSelected && data?.statusId!=2) {
                                      <label class="col-title">
                                        Fluzone High-Dose Influenza Vaccine
                                      </label>
                                    }
                                  </div>
                                  <div class="col-6 status-txt loc-switch mt-3">
                                    @if (data.isSelected) {
                                      <span class="loc_stat">
                                        @if (data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available') {
                                          <label class="switch"
                                            > @if (data?.fluZoneOptedIn=='Offered') {
                                            <input
                                              type="checkbox" class="imCheck"
                                              (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',false)"
                                              checked>
                                          }
                                          @if (data?.fluZoneOptedIn!='Offered') {
                                            <input type="checkbox" class="imCheck"
                                              (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',true)"
                                              >
                                          }
                                          <span class="slider round"></span>
                                        </label>
                                      }
                                      @if (data?.statusId!=2) {
                                        <span>{{data?.fluZoneOptedIn}}</span>
                                      }
                                    </span>
                                  }
                                </div>
                                <div class="col-12 text-center">
                                  <button (click)="cancelEditSection(data.locatorId)"
                                    class="popover-close btn white-button popover-cancel-button mr-3">
                                  Cancel</button>
                                  @if (phoneErrorMsg||cityErrorMsg||cityErrorMsg2 || zipcodeErrorMsg2 || zipcodeErrorMsg || addressErrorMsg || nameErrorMsg) {
                                    <button
                                      disabled (click)="SaveAction()" class="btn btn-primary">
                                    &nbsp;Save&nbsp;</button>
                                  }
                                  @if (!phoneErrorMsg && !cityErrorMsg2 && !zipcodeErrorMsg2 && !zipcodeErrorMsg && !addressErrorMsg && !nameErrorMsg) {
                                    <button
                                      (click)="SaveAction()" class="btn btn-primary">
                                    &nbsp;Save&nbsp;</button>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </section>
                      }
                    }
                    @if (ordersList?.length==0) {
                      <div class="alignCenter">No matching locations</div>
                    }

                  </div>
                  <!--mobile view ends-->
                </div>
              </section>


            </div>
          </div>
